import React from 'react';
import { Microscope, Target } from 'lucide-react';
export function Mission() {
  return <section className="py-16 bg-white" data-id="element-222" data-mp="4trc29c0u3ve">
      <div className="container mx-auto px-4" data-id="element-223" data-mp="4syadmrx64k4">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-224" data-mp="ji48f7f0toqf">
          <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-225" data-mp="jhknrixzkm8p">
            Who We Are & Our Mission
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-226" data-mp="eln8lfygllxi"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-227" data-mp="3mzclzf2pu2fc">
          <div className="bg-navy-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-228" data-mp="3i0jbzwmn0tjx">
            <div className="flex items-center mb-4" data-id="element-229" data-mp="3w011ke7rcauc">
              <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-230" data-mp="3vxob1cnxos5o">
                <Microscope className="text-teal-600" size={24} data-id="element-231" data-mp="3rxe705jpcbtg" />
              </div>
              <h3 className="text-xl font-bold text-navy-800" data-id="element-232" data-mp="1b8ifoksj42t4">Who We Are</h3>
            </div>
            <p className="text-navy-700 mb-4" data-id="element-233" data-mp="178q37x00lcih">
              The California Institute for Microbiome Research (CalMiR) is an
              independent, science-first research institute founded in 2024 and
              dedicated to applying pharmaceutical-grade rigor to microbiome and
              wellness science. We stand as an academic-style flagship while
              remaining translational — ensuring that discoveries move beyond
              the lab into validated products, certifications, and global health
              solutions.
            </p>
          </div>
          <div className="bg-navy-50 p-8 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-234" data-mp="13l217eetew4x">
            <div className="flex items-center mb-4" data-id="element-235" data-mp="18kochib322b3">
              <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-236" data-mp="18j3jhx4f2rfc">
                <Target className="text-teal-600" size={24} data-id="element-237" data-mp="1dc6gkf8ekj0a" />
              </div>
              <h3 className="text-xl font-bold text-navy-800" data-id="element-238" data-mp="fwag16zn7e1n">Our Mission</h3>
            </div>
            <p className="text-navy-700 mb-4" data-id="element-239" data-mp="kuk9nd5py6l5">
              To bridge the gap between biohacker discoveries, consumer wellness
              products, and pharma-level science — by conducting credible,
              reproducible studies that empower consumers, clinicians, and
              policymakers with truth-driven health innovation.
            </p>
            <p className="text-navy-700" data-id="element-240" data-mp="1wx9y3urxxvp6">
              We apply pharmaceutical-grade research rigor to microbiome and
              wellness science—validating what works, debunking what doesn't,
              and ensuring global communities benefit from truth-driven health
              innovation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}